import { render } from "./muted.vue?vue&type=template&id=0130b0c8"
const script = {}
script.render = render

export default script